export default {
  navigation: {
    next: "Okulandelayo",
    back: "Emuva",
    surveyNavigation: "Ukuzulazula kwenhlolovo",
    workspace: {
      home: "Ikhaya",
      example: "Isibonelo"
    }
  }
}
